// ======================================================================
// 📁 File: src/modules/expense_management/routes/ExpenseManagementRoutes.js
// 📝 Purpose:
//   Route configuration for Expense Management module
// ======================================================================

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import ExpenseManagementLayout from "../ExpenseManagementLayout";

// ======================================================================
// DASHBOARD
// ======================================================================

//import ExpenseDashboardPage from "../dashboard/pages/ExpenseDashboardPage";
import ExpenseDashboardPage from "../common/pages/ComingSoonPage";
// ======================================================================
// COMMON
// ======================================================================

import ComingSoonPage from "../common/pages/ComingSoonPage";

// ======================================================================
// CLAIMS
// ======================================================================

import ExpenseClaimListPage from "../claims/pages/ExpenseClaimListPage";
import CreateExpenseClaimPage from "../claims/pages/CreateExpenseClaimPage";
import ExpenseClaimViewPage from "../claims/pages/ExpenseClaimViewPage";
import EditExpenseClaimPage from "../claims/pages/EditExpenseClaimPage";

import WorkflowListPage from "../workflow/pages/WorkflowListPage";

import WorkflowDetailsPage from "../workflow/pages/WorkflowDetailsPage";

import ApprovalMatrixPage from "../workflow/pages/ApprovalMatrixPage";

// ======================================================================
// ROUTES
// ======================================================================

export default function ExpenseManagementRoutes() {

  return (

    <ExpenseManagementLayout>

      <Routes>

        {/* ========================================================= */}
        {/* DEFAULT */}
        {/* ========================================================= */}

        <Route
          path="/"
          element={
            <Navigate
              to="dashboard"
              replace
            />
          }
        />

        {/* ========================================================= */}
        {/* DASHBOARD */}
        {/* ========================================================= */}

        <Route
          path="dashboard"
          element={<ExpenseDashboardPage />}
        />

        {/* ========================================================= */}
        {/* OPERATIONS */}
        {/* ========================================================= */}

        <Route
          path="my-expenses"
          element={<ComingSoonPage title="My Expenses" />}
        />

        <Route
          path="claims"
          element={<ExpenseClaimListPage title="Expense Claims" />}
        />
        <Route
          path="claims/create"
          element={<CreateExpenseClaimPage />}
        />
        
        <Route
          path="claims/edit/:id"
          element={<EditExpenseClaimPage />}
        />
        <Route
          path="claims/:id"
          element={<ExpenseClaimViewPage />}
        />


        <Route
          path="advances"
          element={<ComingSoonPage title="Expense Advances" />}
        />

        <Route
          path="approvals"
          element={<ComingSoonPage title="Expense Approvals" />}
        />

        <Route
          path="payments"
          element={<ComingSoonPage title="Expense Payments" />}
        />

        <Route
          path="settlements"
          element={<ComingSoonPage title="Expense Settlements" />}
        />

        {/* ========================================================= */}
        {/* REPORTS */}
        {/* ========================================================= */}

        <Route
          path="reports/register"
          element={<ComingSoonPage title="Expense Register Report" />}
        />

        <Route
          path="reports/claims"
          element={<ComingSoonPage title="Expense Claim Report" />}
        />

        <Route
          path="reports/approvals"
          element={<ComingSoonPage title="Expense Approval Report" />}
        />

        <Route
          path="reports/payments"
          element={<ComingSoonPage title="Expense Payment Report" />}
        />

        <Route
          path="reports/advances"
          element={<ComingSoonPage title="Expense Advance Report" />}
        />

        <Route
          path="reports/settlements"
          element={<ComingSoonPage title="Expense Settlement Report" />}
        />

        <Route
          path="reports/mileage"
          element={<ComingSoonPage title="Mileage Report" />}
        />

        <Route
          path="reports/per-diem"
          element={<ComingSoonPage title="Per Diem Report" />}
        />

        <Route
          path="reports/policy-violations"
          element={<ComingSoonPage title="Policy Violation Report" />}
        />
                {/* ========================================================= */}
        {/* MASTERS */}
        {/* ========================================================= */}

        <Route
          path="masters/category"
          element={<ComingSoonPage title="Expense Category" />}
        />

        <Route
          path="masters/type"
          element={<ComingSoonPage title="Expense Type" />}
        />

        <Route
          path="masters/payment-mode"
          element={<ComingSoonPage title="Payment Mode" />}
        />

        <Route
          path="masters/currency"
          element={<ComingSoonPage title="Currency" />}
        />

        <Route
          path="masters/mileage-rate"
          element={<ComingSoonPage title="Mileage Rate" />}
        />

        <Route
          path="masters/per-diem-rate"
          element={<ComingSoonPage title="Per Diem Rate" />}
        />

        <Route
          path="masters/tax"
          element={<ComingSoonPage title="Tax" />}
        />

        <Route
          path="masters/vendor"
          element={<ComingSoonPage title="Vendor" />}
        />

        <Route
          path="masters/cost-center"
          element={<ComingSoonPage title="Cost Center" />}
        />

        <Route
          path="masters/project"
          element={<ComingSoonPage title="Project" />}
        />

        <Route
          path="masters/expense-reason"
          element={<ComingSoonPage title="Expense Reason" />}
        />

        <Route
          path="masters/receipt-type"
          element={<ComingSoonPage title="Receipt Type" />}
        />

        <Route
          path="masters/approval-level"
          element={<ComingSoonPage title="Approval Level" />}
        />

        <Route
          path="masters/reimbursement-method"
          element={<ComingSoonPage title="Reimbursement Method" />}
        />

        <Route
          path="masters/expense-policy"
          element={<ComingSoonPage title="Expense Policy" />}
        />

        <Route
          path="masters/expense-policy-rule"
          element={<ComingSoonPage title="Expense Policy Rule" />}
        />

        {/* ========================================================= */}
        {/* CONFIGURATION */}
        {/* ========================================================= */}

        <Route
        path="configuration/approval-workflow"
            element={<WorkflowListPage />}
        />

        <Route
            path="configuration/approval-workflow/:workflowId"
            element={<WorkflowDetailsPage />}
        />

        <Route
          path="configuration/approval-rules"
          element={<ApprovalMatrixPage />}
        />

        <Route
          path="configuration/number-series"
          element={<ComingSoonPage title="Number Series" />}
        />

        <Route
          path="configuration/settings"
          element={<ComingSoonPage title="Expense Settings" />}
        />

        <Route
          path="configuration/notification-rules"
          element={<ComingSoonPage title="Notification Rules" />}
        />

        <Route
          path="configuration/policy"
          element={<ComingSoonPage title="Policy Configuration" />}
        />

        {/* ========================================================= */}
        {/* FALLBACK */}
        {/* ========================================================= */}

        <Route
          path="*"
          element={
            <Navigate
              to="dashboard"
              replace
            />
          }
        />

      </Routes>

    </ExpenseManagementLayout>

  );

}